import React from 'react';
import { useTranslation } from 'react-i18next';


const Skills = () => {
  const { t } = useTranslation();

  return (
    <div className='skills'>
      <h2 className='underline-title'>{t('skills.title')}</h2>
      <div className='content-column-container'>
        <div className='content-column'>
          <div className='content-block'>
            <h3 className='title'>{t('skills.1.title')}</h3>
            <p className='items'>{t('skills.1.items')}</p>
          </div>
          <div className='content-block'>
            <h3 className='title'>{t('skills.2.title')}</h3>
            <p className='items'>{t('skills.2.items')}</p>
          </div>
          <div className='content-block'>
            <h3 className='title'>{t('skills.3.title')}</h3>
            <p className='items'>{t('skills.3.items')}</p>
          </div>
        </div>
        <div className='content-column'>
          <div className='content-block'>
            <h3 className='title'>{t('skills.4.title')}</h3>
            <p className='items'>{t('skills.4.items')}</p>
          </div>
          <div className='content-block'>
            <h3 className='title'>{t('skills.5.title')}</h3>
            <p className='items'>{t('skills.5.items')}</p>
          </div>
          <div className='content-block'>
            <h3 className='title'>{t('skills.6.title')}</h3>
            <p className='items'>{t('skills.6.items')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
